import classNames from 'classnames';

import * as styles from './styles.module.scss';

interface ShinyLoaderProps {
    isLoaded: boolean;
    className?: string;
}

export default function ShinyLoader({ isLoaded, className }: ShinyLoaderProps) {
    return <div className={classNames(styles.ShinyLoader, { [styles.isLoaded]: isLoaded }, className)}></div>;
}
